import { render, staticRenderFns } from "./ProofView.vue?vue&type=template&id=ab91be12&"
import script from "./ProofView.vue?vue&type=script&lang=js&"
export * from "./ProofView.vue?vue&type=script&lang=js&"
import style0 from "./ProofView.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VLayout,
})
